import mutations from './moduleSurveyMutations'
import getDefaultState from './moduleSurveyState'
import actions from './moduleSurveyActions'
import getters from './moduleSurveyGetters'



const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters 
}